import { Box, Text } from '@medely/ui-kit';
import React from 'react';

export const StipendModalInfo = () => {
  return (
    <>
      <Box pb={2} testId="stipend-modal">
        <Text size="l" textAlign="justify">
          Medely has partnered with Frontline Health to offer a W2 option to Medely professionals.
        </Text>
      </Box>
      <Box pb={2}>
        <Text size="l" textAlign="justify">
          Stipends are meant for reimbursement not as income. Stipends are calculated to reimburse
          your lodging, meals, and incidentals while working away from home. You’ll receive these
          Stipends as a lump sum each pay period. Our stipends are based off the recommendations
          from the U.S. General Service Administration for the time of year of the assignment and
          the zip code of the facility. Your eligibility for a tax-free stipend is based on IRS
          guidelines and while we’re here to help, we’d suggest you talk to a tax professional if
          you have any questions about your specific situation.
        </Text>
      </Box>
      <Text size="l" textAlign="justify">
        We don’t include Stipends in your Hourly Rate. Our stipends are provided for your daily
        expenses for the duration of the contract and not tied to the number of hours you work.
      </Text>
    </>
  );
};
